/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { LoneIconButton } from '@blend/enterprise-components';
import { UserIconButton } from 'blb-components/AuthenticatedApp/UserIconButton';
import { HelpAction } from 'blb-components/AuthenticatedApp/HelpAction';

export namespace Sidebar {
  export interface Props {}
}

export const Sidebar: React.FC<Sidebar.Props> = ({}) => {
  const history = useHistory();
  return (
    <>
      <LoneIconButton btnSize="sm" icon="arrow_back" iconSize={24} onClick={history.goBack} theme="light" />
      <div>
        <UserIconButton />
        <HelpAction />
      </div>
    </>
  );
};
